import React, { Component } from 'react'
import {observer, inject} from 'mobx-react';
import { translate } from 'react-i18next'
import i18n from '../../../i18n'

import { H1 } from '../../global/typography/typography'
import P4PAALogo from '../../../static/svgs/p4paa-logo.svg'
import P4PAALogoEs from '../../../static/svgs/p4paa-logo-es.svg'
import MapLegendPaved from '../../../static/svgs/legend-partner-states.svg'
import MapLegendPavedStories from '../../../static/svgs/legend-partner-states-stories.svg'
import mobileMap from '../../../static/images/map-mobile.png'
import Map from './Map'

import {
  MapHeroWrapper,
  LangToggles,
  StateInfo,
  MapLocation,
  MapLocationStats,
  NotPaved,
  ComingSoon,
  CampaignIntroWrapper
} from './styled-components'

// allow for non-empty but falsy attributes to register as false
const attributeIsFalsy = value => {
  return value === 'false' || value === '' || (!!value) === false
}
const boolifyAttributeValue = value => {
  return attributeIsFalsy(value) ? false : true
}

const Stats = ({ stat1number, stat1text, stat2number, stat2text, month, date, dateText }) => (
  <ul className='map-stats'>
    <li>
      <span className='map-stats__number'>{stat1number}</span>
      <span className='map-stats__text'>{stat1text}</span>
    </li>
    <li>
      <span className='map-stats__number'>{stat2number}</span>
      <span className='map-stats__text'>{stat2text}</span>
    </li>
    <li>
      <span className='map-stats__date'>{month}</span>
      <span className='map-stats__date'>{date}</span>
      <span className='map-stats__text'>{dateText}</span>
    </li>
  </ul>
)

const ComingSoonContent = ({ season, year, comingSoonText }) => (
  <div>
    <p>
      <span className='map-stats__date'>{season}</span>
      <span className='map-stats__date'>{year}</span>
      <span className='map-stats__text'>{comingSoonText}</span>
    </p>
  </div>
)

const NotPavedContent = ({t}) => (
  <div>
    <p><span className='map-stats__date'>{t('mapHero.tooltip.soon')}</span></p>
  </div>
)

@inject("store")
@observer class MapHero extends Component {
  constructor (props) {
    super(props)

    this.state = {
      city: '',
      state: '',
      stat1number: '',
      stat1text: '',
      stat2number: '',
      stat2text: '',
      month: '',
      date: '',
      dateText: '',
      season: '',
      year: '',
      comingSoonText: '',
      tooltipCopy: '',
      displayIntroText: true,
      displayPaved: false,
      displayNotPaved: false,
      displayComingSoon: false,
      displayStateInfo: false
    }

    this.scrollToElement = this.scrollToElement.bind(this)
    this.gaLangClicked = this.gaLangClicked.bind(this)
    this.toggle = this.toggle.bind(this)
    this.langToggle = this.langToggle.bind(this)
    this.getCityData = this.getCityData.bind(this)
    this.clearCityData = this.clearCityData.bind(this)
    this.gaStateClicked = this.gaStateClicked.bind(this)
    this.positionTooltips = this.positionTooltips.bind(this)

    this.tooltips = []

    this.handleMouseMove = e => {
      this.positionTooltips({
        x: e.clientX,
        y: e.clientY + window.pageYOffset
      })
    }
  }

  componentDidMount () {
    this.tooltips = [
      document.querySelector('.tooltip--paved'),
      document.querySelector('.tooltip--not-paved'),
      document.querySelector('.tooltip--coming-soon')
    ]
    window.addEventListener('mousemove', this.handleMouseMove)
  }

  componentWillUnmount () {
    this.tooltips = []
    window.removeEventListener('mousemove', this.handleMouseMove)
  }

  getCityData (e) {
    const city = e.target.getAttribute('data-city')
    const state = e.target.getAttribute('data-state')
    const stat1number = e.target.getAttribute('data-stat1number')
    const stat1text = e.target.getAttribute('data-stat1text')
    const stat2number = e.target.getAttribute('data-stat2number')
    const stat2text = e.target.getAttribute('data-stat2text')
    const month = e.target.getAttribute('data-month')
    const date = e.target.getAttribute('data-date')
    const dateText = e.target.getAttribute('data-date-text')
    const season = e.target.getAttribute('data-season')
    const year = e.target.getAttribute('data-year')
    const comingSoonText = e.target.getAttribute('data-coming-soon-text')
    const tooltipCopy = e.target.getAttribute('data-tooltip-copy')
    const paved = boolifyAttributeValue(e.target.getAttribute('data-paved'))
    const notPaved = boolifyAttributeValue(e.target.getAttribute('data-not-paved'))
    const comingSoon = boolifyAttributeValue(e.target.getAttribute('data-coming-soon'))

    this.setState({
      city: city,
      state: state,
      stat1number: stat1number,
      stat1text: stat1text,
      stat2number: stat2number,
      stat2text: stat2text,
      month: month,
      date: date,
      dateText: dateText,
      season: season,
      year: year,
      comingSoonText: comingSoonText,
      tooltipCopy: tooltipCopy,
      displayIntroText: false,
      displayPaved: paved,
      displayNotPaved: notPaved,
      displayComingSoon: comingSoon,
      displayStateInfo: paved || notPaved || comingSoon
    })

    if (e.target.getAttribute('class') === 'paved') {
      e.target.setAttribute('class', 'paved hovered')
    } else if (e.target.getAttribute('class') === 'upcoming') {
      e.target.setAttribute('class', 'upcoming hovered')
    } else if (e.target.getAttribute('class') === 'tag') {
      e.target.setAttribute('class', 'tag hovered')
    } else if (e.target.getAttribute('class') === 'not-paved') {
      e.target.setAttribute('class', 'not-paved hovered')
    }

    if (e.target.getAttribute('data-state') === 'TX') {
      document.querySelector('#TX-north').classList.add('hovered')
      document.querySelector('#TX-south').classList.add('hovered')
    }

  }

  positionTooltips ({ x, y }) {
    const nudge = { x: 26, y: 58 }  // ?? mystery amounts
    for (const tooltip of this.tooltips) {
      tooltip.style.left = `${x - (tooltip.offsetWidth / 2) - nudge.x}px`;
      tooltip.style.top = `${y - tooltip.offsetHeight - nudge.y}px`;
    }
  }

  clearCityData (e) {
    this.setState({
      city: '',
      state: '',
      stat1number: '',
      stat1text: '',
      stat2number: '',
      stat2text: '',
      month: '',
      date: '',
      dateText: '',
      season: '',
      year: '',
      comingSoonText: '',
      tooltipCopy: '',
      displayIntroText: true,
      displayPaved: false,
      displayNotPaved: false,
      displayComingSoon: false,
      displayStateInfo: false
    })

    if (e.target.getAttribute('class') === 'paved hovered') {
      e.target.setAttribute('class', 'paved')
    }

    if (e.target.getAttribute('class') === 'upcoming hovered') {
      e.target.setAttribute('class', 'upcoming')
    }

    if (e.target.getAttribute('class') === 'tag hovered') {
      e.target.setAttribute('class', 'tag')
    }

    if (e.target.getAttribute('data-state') === 'TX') {
      document.querySelector('#TX-north').classList.remove('hovered')
      document.querySelector('#TX-south').classList.remove('hovered')
    }
  }

  scrollToElement (element) {
    const target = document.querySelector(element)
    target.scrollIntoView({ behavior: 'smooth' })
  }

  gaStateClicked (city, state, status) {
    window.dataLayer.push({
      'event': 'map:click',
      'city': `${city}, ${state}`,
      'digital state': status
    })
  }

  gaLangClicked (lng) {
    window.dataLayer.push({
      'event': 'lang:click',
      'langSelect': 'header',
      'langSelectItem': lng
    })
  }

  toggle (lng) {
    i18n.changeLanguage(lng)
  }

  langToggle (lng) {
    this.toggle(lng)
    this.gaLangClicked(lng)
  }


  render () {
    const {
      scrollToElement,
      langToggle,
      getCityData,
      clearCityData,
      gaStateClicked
    } = this
    const {
      city,
      state,
      stat1number,
      stat1text,
      stat2number,
      stat2text,
      month,
      date,
      dateText,
      season,
      year,
      comingSoonText,
      tooltipCopy,
      displayIntroText,
      displayPaved,
      displayNotPaved,
      displayComingSoon,
      displayStateInfo
    } = this.state
    const { data, t, lng } = this.props

    return (
      <MapHeroWrapper>
        <LangToggles>
          <p>Language:</p> <button onClick={() => langToggle('en')}>EN</button> <button onClick={() => langToggle('es')}>ES</button>
        </LangToggles>

        {
          lng.match(/^en/) ? <P4PAALogo /> : <P4PAALogoEs />
        }

        <img
          className='map-hero__mobile-map'
          src={mobileMap}
          alt="Unites States map indicates states we've paved"
          onClick={() => scrollToElement('#cities-completed')}
          onKeyDown={() => scrollToElement('#cities-completed')}
          role='button'
          tabIndex={0}
        />

        <Map
          className='map-hero__desktop-map'
          city={city}
          state={state}
          displayPaved={displayPaved}
          displayNotPaved={displayNotPaved}
          displayComingSoon={displayComingSoon}
          tooltipCopy={tooltipCopy}
          getCityData={(e) => getCityData(e)}
          clearCityData={clearCityData}
          gaStateClicked={gaStateClicked}
          scrollToElement={scrollToElement}
        />

        <StateInfo displayStateInfo={displayStateInfo}>
          <MapLocation>
            <span className='map-data-city'>{city}</span>
            <span className='map-data-state'>{state}</span>
          </MapLocation>

          <MapLocationStats>
            <Stats
              stat1number={stat1number}
              stat1text={stat1text}
              stat2number={stat2number}
              stat2text={stat2text}
              month={month}
              date={date}
              dateText={dateText}
            />

            <ComingSoon style={{ display: displayComingSoon ? 'block' : 'none' }}>
              <ComingSoonContent season={season} year={year} comingSoonText={comingSoonText} />
            </ComingSoon>

            <NotPaved style={{ display: displayNotPaved ? 'block' : 'none' }}>
              <NotPavedContent state={city} t={t} />
            </NotPaved>
          </MapLocationStats>
        </StateInfo>

        <CampaignIntroWrapper lang={lng} margins={[140, 140, 120]} style={{ display: displayIntroText ? 'block' : 'none' }}>
          <div className='eyebrow'>
            <H1 color={data.eyebrowColor}>{t('mapHero.campaignIntro.eyebrow')}</H1>
          </div>
          <div className='copy'>
            <p>{t('mapHero.campaignIntro.text')}</p>
          </div>
        </CampaignIntroWrapper>
      </MapHeroWrapper>
    )
  }
}

export default translate()(MapHero)



// WEBPACK FOOTER //
// ./src/components/modules/MapHero/MapHero.js